

<template>
	<section
		class="image_content"
		:style="{
			'--heading-colour': headingColour ? headingColour : '#707070',
			'--content-colour': contentColour ? contentColour : '#707070',
			'--background-colour': backgroundColour,
			'--image-max-height': imageMaxHeight + 'px',
			'--font-size': fontSize + 'px',
			'--font-line-height': fontLineHeight + 'px',
			'--image-cover-contain': coverOrContain,
		}"
	>
		<div
			class="container"
			:class="{
				right: copyPosition === 'right',
				left: copyPosition === 'left',
				full: featureImage === 'false'
			}"
		>
			<div class="inner">
				<div class="half content">
					<h2
						v-if="featureTitle"
						v-html="featureTitle"
					></h2>

					<div
						class="feature_copy"
						v-if="featureCopy"
						v-html="featureCopy"
					></div>

					<site-button
						v-for="(button, index) in JSON.parse(buttons)"
						:key="index"
						:link="button.button_link"
						:label="button.button_label ? button.button_label : button.button_link.title"
						:colour="button.button_colour"
						:button_text_colour="button.button_text_colour"
					></site-button>
				</div>

				<div class="half image" v-if="featureImage != 'false'">
					<img
						v-if="featureImage != false"
						v-lazy="JSON.parse(featureImage).url"
						class="lazy"
						:alt="JSON.parse(featureImage).alt ? JSON.parse(featureImage).alt : featureTitle"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import SiteButton from './SiteButton.vue';
import SampleImage from '../../images/sample.jpg';

export default {
	data() {
		return {
			sampleImage: SampleImage,
		};
	},

	props: {
		featureTitle: {},
		featureCopy: {},
		featureImage: {},
		copyPosition: {
			default: 'left',
		},
		buttons: {},
		contentColour: {
			default: '#000',
		},
		headingColour: {
			default: '#000',
		},
		backgroundColour: {
			default: 'transparent',
		},
		imageMaxHeight: {
			default: '600',
		},
		fontSize: {
			default: '50',
		},

		fontLineHeight: {
			default: '60',
		},
		coverOrContain: {
			default: 'cover',
		},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {
		SiteButton,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.image_content {
	background: var(--background-colour);
	// min-height: 500px;
	width: 100%;
	margin: 0;
	// padding: $spacer * 4 0;

	@media (max-width: $lg) {
		margin: 0 0;
		// padding: $spacer;
	}

	.container {
		@media (max-width: $lg) {
			padding: 0;
		}

		&.left {
			// padding: 0 0 0 20px;

			.inner {
				grid-template-columns: 1fr 50%;
				width: 100%;

				.content {
					order: 0;

					@media (max-width: $lg) {
						grid-column: span 2;
						order: 1;
					}
				}

				.image {
					order: 1;

					@media (max-width: $lg) {
						height: 240px;
						grid-column: span 2;
						order: 0;
					}
				}
			}

			&.full {
				.inner {
					grid-template-columns: 1fr;
				}
			}
		}

		&.right {
			// padding: 0 20px 0 0;

			.inner {
				grid-template-columns: 50% 1fr;
				width: 100%;

				.content {
					order: 1;

					@media (max-width: $lg) {
						grid-column: span 2;
					}
				}

				.image {
					order: 0;

					@media (max-width: $lg) {
						height: 240px;
						grid-column: span 2;
					}
				}
			}

			&.full {
				.inner {
					grid-template-columns: 1fr;
				}
			}
		}
	}

	.inner {
		display: grid;
		column-gap: 50px;
		// overflow-x: hidden;

		@media (max-width: $xl) {
			column-gap: auto;
			padding: 0;
		}

		.half {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.site_button {
				margin-bottom: $spacer;

				&:last-of-type {
					margin-bottom: 0;
				}
			}

			&.content {
				padding: $spacer * 2 0;

				@media (max-width: $max-width) {
					padding: $spacer;
				}

				h2 {
					color: var(--heading-colour);
					margin: 0 0 $spacer * 2;
					font-size: var(--font-size);
					line-height: var(--font-line-height);
					font-family: $font-family;
					font-weight: normal;

					@media (max-width: $lg) {
						font-size: 34px;
						line-height: 40px;
						margin: 0 0 $spacer;
					}
				}

				strong {
					color: var(--content-colour);
					margin: 0 0 $spacer * 2;
					font-size: 18px;

					@media (max-width: $lg) {
						font-size: 18px;
						margin: 0 0 $spacer;
					}
				}

				.feature_copy {
					& ::v-deep p {
						color: var(--content-colour);
						margin: 0 0 $spacer * 2;
						font-size: 18px;
						line-height: 30px;

						@media (max-width: $lg) {
							font-size: 18px;
							margin: 0 0 $spacer;
						}
					}

					& ::v-deep a {
						font-size: 18px;
						line-height: 30px;
						color: inherit;

						@media (max-width: $lg) {
							font-size: 18px;
						}
					}
				}

				
			}

			img {
				width: 100%;
				object-fit: var(--image-cover-contain);
				height: 100%;
				max-height: var(--image-max-height);
				max-width: 100%;

				@media (max-width: $lg) {
					max-height: 240px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ImageContentSection.vue